import { render, staticRenderFns } from "./history-item.vue?vue&type=template&id=7b3dbede"
import script from "./history-item.vue?vue&type=script&lang=js"
export * from "./history-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports